import { useEffect, useState, useRef, useContext } from 'react'
import { MOCK_ANSWER_SUBMIT, INTERVIEW_SUBMIT } from '../../Utils/apis';
import { MockInterviewContext } from '../../Contexts/mockInterviewContext';
import { useSelector } from 'react-redux';

const useRecordMockInterview = (paramsObj) => {
    const { currentMockId, questionNumber, onSucess, onInterviewEnd } = paramsObj;
    const { setUploading, updateInterviewStatusToEnd } = useContext(MockInterviewContext);
    const noOfQuestions = useSelector(store => store?.mocks?.[currentMockId]?.questions?.length);




    // these two state for window / tab switch  detection
    const windowVisibilityList = useRef([]);
    const interviewStartedTime = useRef(0);


    const recorder = useRef();
    let { current: chunck } = useRef([]);

    let { current: stream } = useRef(null);
    let { current: audio } = useRef(null);

    let { current: submitType } = useRef('ANSWER')

    const interviewStop = () => { recorder.current?.stop(); };

    const onStop = async () => {
        setUploading(true);
        const blob = new Blob(chunck, { type: 'video/webm' });
        const formData = new FormData();

        chunck = [];

        formData.append('video', blob);
        formData.append('mockId', currentMockId);
        formData.append('qnum', questionNumber);


        try {
            const res = await fetch(MOCK_ANSWER_SUBMIT, { method: 'POST', body: formData, credentials: 'include', });

            if (res.ok) {
                const data = await res.json();

                if(questionNumber === noOfQuestions){
                    updateInterviewStatusToEnd();
                }

                if (submitType === 'END') {
                    onInterviewEnd();
                } else { onSucess(); }


            }

        } catch (err) {
            // console.error('Error uploading chunk:', err);
        } finally {
            setUploading(false);
        }

        stream.getTracks().forEach((track) => track.stop());
        audio.getTracks().forEach((track) => track.stop());
    };

    const endInterview = async () => {
        try {
            submitType = 'END';
            interviewStop();
            const res = await fetch(INTERVIEW_SUBMIT, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ id: currentMockId }),
                credentials: 'include',
            });

            if (!res.ok) {
                throw new Error("somthing went wrong");
            }

        }
        catch (error) {
            // console.log("interview ending api error : ", error);
        }
    }

    useEffect(() => {
        let mixedStream;
        (
            async () => {
                try {
                    stream = await navigator.mediaDevices.getUserMedia({
                        video: {
                            width: { ideal: 360 },
                            height: { ideal: 180 },
                        }
                    });
                    audio = await navigator.mediaDevices.getUserMedia({
                        audio: {
                            echoCancellation: true,
                            noiseSuppression: true,
                            sampleRate: 44100,
                        },
                    });
                }
                catch (err) {
                    alert("Please grant permission for the camera and microphone.");
                }

                if (stream && audio) {
                    mixedStream = new MediaStream([...stream.getTracks(), ...audio.getTracks()]);
                    recorder.current = new MediaRecorder(mixedStream);

                    recorder.current.ondataavailable = (e) => chunck.push(e.data);
                    recorder.current.onstop = onStop;
                    recorder.current.start(1000);
                }
                else {
                    console.warn('No stream available.');
                }
            }
        )();

        return () => {
            mixedStream?.getTracks()?.forEach(track => track?.stop());
        }
    }, []);

    return [interviewStop, endInterview]
}
export default useRecordMockInterview;